import WebmVideo from 'src/shared/components/ui/video/webm-video'
import GolfVideoFallback from 'src/shared/features/enterprise/assets/golf-vid.mov'
import GolfVideoWebm from 'src/shared/features/enterprise/assets/golf-vid.webm'
import BaseballVideoFallback from 'src/shared/features/home/assets/baseball-vid.mov'
import BaseballVideoWebm from 'src/shared/features/home/assets/baseball-vid.webm'
// TODO: Add webm video
import useBreakpoint from 'src/shared/hooks/use-breakpoint'
import { cn } from 'src/shared/utils/cn'

const ConsumerSideContent = () => {
  return (
    <div className="relative flex flex-1">
      <WebmVideo
        src={BaseballVideoWebm}
        fallbackSrc={BaseballVideoFallback}
        className="size-full object-cover"
        containerClassName="absolute inset-0"
        loop={true}
        autoPlay={true}
        muted={true}
      />
      <p className="absolute inset-x-0 bottom-0 px-[54px] pb-[54px] text-[36px] font-medium leading-[1.3] tracking-[-0.84px] text-white lg:pb-[78px] lg:text-[42px]">
        Where home happens.
      </p>
    </div>
  )
}

const EnterpriseSideContent = () => {
  return (
    <div className="relative flex flex-1">
      <WebmVideo
        src={GolfVideoWebm}
        fallbackSrc={GolfVideoFallback}
        className="size-full object-cover"
        containerClassName="absolute inset-0"
        loop={true}
        autoPlay={true}
        muted={true}
      />
      <p className="absolute inset-x-0 bottom-0 px-[54px] pb-[54px] text-[36px] font-medium leading-[1.3] tracking-[-0.84px] text-white lg:pb-[78px] lg:text-[42px]">
        Where home happens.
      </p>
    </div>
  )
}

interface EnterpriseAuthSideContentProps {
  variant?: 'default' | 'consumer'
}

export default function EnterpriseAuthSideContent({ variant = 'default' }: EnterpriseAuthSideContentProps) {
  const { isMobile } = useBreakpoint()

  return (
    <div
      className={cn(
        'relative flex flex-1 flex-col overflow-hidden rounded-[40px] bg-white',
        isMobile && 'w-full border border-border shadow-[0_2px_20px_0_rgba(27,48,41,0.05)]',
      )}
    >
      {variant === 'default' && <EnterpriseSideContent />}
      {variant === 'consumer' && <ConsumerSideContent />}
    </div>
  )
}
